import { FC, ReactNode, useCallback, useMemo } from "react";

import __ from "web/Layout/Translations";

import Title from "web/Components/Common/Title";

import { ModalActionTypes } from "web/hooks/useModal/useModalTypes";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";
import prepareGroupBenefitsSummary from "web/utils/page/customer/prepareGroupBenefitsSummary";
import filterOutHiddenBenefits from "web/utils/page/product/subscription/filterOutHiddenBenefits";

import {
  ISubscriptionItemCurrentUserSubscription,
  ISubscriptionUserCurrent,
  RelationBenefitAutomaticTypeConfiguration,
} from "web/types/Subscription";

import { useAppContext } from "web/context/app";

import BenefitSummary from "../../BenefitSummary/benefitSummary";
import classes from "./successList.scss";

interface ISuccessListProps {
  data: ISubscriptionUserCurrent;
}

const titleClasses = { header: classes.header };

const CheckoutSubscriptionSuccessList: FC<ISuccessListProps> = ({ data }) => {
  const { modal } = useAppContext();
  const { dispatch } = modal;
  const setModal = useCallback(
    (content: ReactNode) => {
      dispatch({ type: ModalActionTypes.ADD_MODAL, modal: content });
    },
    [dispatch]
  );

  const benefitsFiltered =
    filterOutHiddenBenefits<ISubscriptionItemCurrentUserSubscription>(
      data.items,
      RelationBenefitAutomaticTypeConfiguration.HIDE_WHEN_CHOOSING_BENEFITS
    );
  const pointsBanks = data?.pointsBanks;

  const benefitList = useMemo(() => {
    if (isArrayHasItems(benefitsFiltered)) {
      const formsDataByGroup =
        prepareGroupBenefitsSummary<ISubscriptionItemCurrentUserSubscription>(
          benefitsFiltered
        );
      return formsDataByGroup.map((group) => {
        return (
          <BenefitSummary
            key={group.groupName}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...group}
            className={classes.benefit}
            pointsBanks={pointsBanks}
            setModal={setModal}
            extendedView
            onlyHeader
            totals={data?.totals}
          />
        );
      });
    }
    return [];
  }, [data]);

  return isArrayHasItems(benefitList) ? (
    <>
      <Title
        name={__("Wybrane abonamenty")}
        classes={titleClasses}
        container="h2"
      />
      {benefitList}
    </>
  ) : null;
};

export default CheckoutSubscriptionSuccessList;
